import { render, staticRenderFns } from "./PerfumeDescription.vue?vue&type=template&id=58857db6"
import script from "./PerfumeDescription.vue?vue&type=script&lang=js"
export * from "./PerfumeDescription.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports